import { useContext } from 'react';
import { useAuth as useAuthBase } from '@leoclinic/hooks';
import type { Clinic } from '@leoclinic/types';
import { AuthContext } from './auth-context';

/**
 * Hook de autenticação da app admin com suporte a modo demo
 */
export function useAppAuth() {
  const { useMock, mockSession, updateMockClinic } = useContext(AuthContext);
  const auth = useAuthBase({ enabled: !useMock });

  if (useMock && mockSession) {
    return {
      session: mockSession,
      user: mockSession.user,
      clinic: mockSession.clinic,
      isLoading: false,
      isAuthenticated: true,
      signIn: async () => mockSession,
      signOut: async () => undefined,
      isSigningIn: false,
      isSigningOut: false,
      signInError: null,
      updateMockClinic,
    };
  }

  return {
    ...auth,
    updateMockClinic: undefined as ((data: Partial<Clinic>) => void) | undefined,
  };
}
